export const accessRoleOptions = [
  {
    value: 2,
    label: "Supervisor",
  },
  {
    value: 3,
    label: "Agente",
  },
  {
    value: 10,
    label: "Supervisor restringido",
  },
];
